import React from 'react';
import Slider from '@mui/material/Slider';
import { joinMultipleStyle } from '../../../Utils/ScssUtils';
import CustomIconButton from '../../Button/CustomIconButton';
import FlexContainer from '../../Container/FlexContainer';
import { IVolumeSlider } from '../SliderFactory';
import useCustomSliderHandler from '../SliderHandlerHook';
import '../SliderStyle.scss';

export type omitProps =
    | 'orientation'
    | 'className'
    | 'defaultValue'
    | 'min'
    | 'max'
    | 'disabled'
    | 'onChange'
    | 'onChangeCommitted'
    | 'onTouchMove'
    | 'onTouchCancel'
    | 'value';

function SliderWithControlButton({
    handleSliderChange,
    handleSliderChangeCommitted,
    onTouchStart,
    sliderState,
    stepAdjustValue = 1,
    thumbImgSrc = `/resources/sharedAcrossWorkflows/volume-slider.svg`,
    loadingPage = false,
    ...others
}: IVolumeSlider): React.ReactElement {
    const {
        sliderPos,
        loading,
        onClickAdjustButton,
        handleOnChangeCommittedSlider,
        handleOnChangeSlider,
        handleSliderStart,
        handleSliderMove,
        handleSliderCancel,
    } = useCustomSliderHandler(
        handleSliderChange,
        handleSliderChangeCommitted,
        sliderState,
        onTouchStart
    );

    const isSliderDisabled = loading || loadingPage;
    const isSliderMinButtonDisabled =
        loading || loadingPage || sliderPos <= sliderState.posMin;
    const isSliderMaxButtonDisabled =
        loading || loadingPage || sliderPos >= sliderState.posMax;

    return (
        <FlexContainer>
            <CustomIconButton
                imgSrc={`/resources/sharedAcrossWorkflows/volume_increase.svg`}
                imgClassName={joinMultipleStyle(
                    'sliderButton',
                    isSliderMaxButtonDisabled ? 'disabled' : ''
                )}
                id={`btn-increment-${others.id}`}
                disabled={isSliderMaxButtonDisabled}
                onClick={async () => {
                    await onClickAdjustButton(stepAdjustValue);
                }}
            />
            <FlexContainer className="sliderContainer">
                <Slider
                    id={others.id}
                    orientation="vertical"
                    className={joinMultipleStyle(
                        'customSlider',
                        isSliderDisabled ? 'disabled' : ''
                    )}
                    aria-label={
                        others['aria-label']
                            ? others['aria-label']
                            : 'Volume Slider'
                    }
                    defaultValue={sliderState.initialPosition}
                    min={sliderState.posMin}
                    max={sliderState.posMax}
                    disabled={isSliderDisabled}
                    // issue on material UI slider https://github.com/mui-org/material-ui/issues/20191
                    onChange={(_, v) => handleOnChangeSlider(v)}
                    onChangeCommitted={(_, v) =>
                        handleOnChangeCommittedSlider(v)
                    }
                    onTouchStart={handleSliderStart}
                    onTouchMove={handleSliderMove}
                    onTouchCancel={handleSliderCancel}
                    // step={stepAdjustValue}
                    value={sliderPos}
                    slotProps={{
                        thumb: {
                            className: 'customSliderThumb',
                            style: {
                                backgroundImage: `url(${thumbImgSrc})`,
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                            } as React.CSSProperties,
                        } as any,
                    }}
                />
            </FlexContainer>
            <CustomIconButton
                imgSrc={`/resources/sharedAcrossWorkflows/volume_decrease.svg`}
                imgClassName={joinMultipleStyle(
                    'sliderButton',
                    isSliderMinButtonDisabled ? 'disabled' : ''
                )}
                id={`btn-decrement-${others.id}`}
                disabled={isSliderMinButtonDisabled}
                onClick={async () => {
                    await onClickAdjustButton(-stepAdjustValue);
                }}
            />
        </FlexContainer>
    );
}

export default SliderWithControlButton;
